import request from "../api/httpClient.js";
import getEndpoint from "../utils/getEndpoint.js";

export const getVisualizations = async (query) => {
  const visualizations = await request(
    getEndpoint("publication", "getPublications"),
    { query },
  );
  return visualizations.data;
};

export const getVisualization = async (publicationId) => {
  const visualization = await request(
    getEndpoint("publication", "getPublication", publicationId),
  );
  return visualization.data;
};

export const getMyVisualizations = async (query) => {
  const visualizations = await request(
    getEndpoint("publication", "getMyPublications"),
    { query },
  );
  return visualizations.data;
};

export const getDraft = async (publicationId) => {
  const visualization = await request(
    getEndpoint("publication", "getDraft", publicationId),
  );
  return visualization.data;
};

export const publishVisualization = async (publicationId) => {
  const visualization = await request(
    getEndpoint("publication", "publishPublication", publicationId),
  );
  return visualization.data;
};

export const unpublishVisualization = async (publicationId) => {
  const visualization = await request(
    getEndpoint("publication", "unpublishPublication", publicationId),
  );
  return visualization.data;
};

export const createVisualization = async (payload) => {
  const publication = await request(
    getEndpoint("publication", "createPublication"),
    { body: payload },
  );
  return publication.data;
};

export const updateVisualization = async (publicationId, payload) => {
  const publication = await request(
    getEndpoint("publication", "updatePublication", publicationId),
    { body: payload },
  );
  return publication.data;
};

export const deleteVisualization = async (publicationId) => {
  await request(getEndpoint("publication", "deletePublication", publicationId));
};

export const resolveVisualizationPath = async (query) => {
  const path = await request(getEndpoint("publication", "resolvePath"), {
    query,
  });
  return path.data;
};
